// extracted by mini-css-extract-plugin
module.exports = {"userDetails":"UserDetails_userDetails__wEsdT"};